export default "__VITE_ASSET__DOu_dxuE__"